import { useState } from 'react'

import { Metadata } from '@redwoodjs/web'

import { PageHeaderLayout } from 'src/components/Core/PageHeaderLayout'
import { RefreshButton } from 'src/components/Core/RefreshButton'

import { ActivityAnalyticsSectionTabs } from '../CallAnalyticsPage/components/ActivityAnalyticsSectionTabs'
import { FiltersSlotProvider } from '../CallAnalyticsPage/components/FiltersPortal'

import SMSAnalyticsTab from './SMSAnalyticsTab'

const SMSAnalyticsPage = () => {
  const [refreshKey, setRefreshKey] = useState(0)
  const [lastUpdatedAt, setLastUpdatedAt] = useState<Date | null>(null)
  const [filtersSlot, setFiltersSlot] = useState<HTMLElement | null>(null)

  const handleRefresh = () => {
    setRefreshKey((k) => k + 1)
    setLastUpdatedAt(new Date())
  }

  return (
    <PageHeaderLayout
      title="SMS Analytics"
      tabs={<ActivityAnalyticsSectionTabs section="sms" />}
      toolbar={
        <>
          <div
            ref={setFiltersSlot}
            data-testid="sms-analytics-filters-slot"
            className="flex flex-wrap items-center gap-1"
          />
          <RefreshButton
            onRefresh={handleRefresh}
            lastUpdatedAt={lastUpdatedAt}
          />
        </>
      }
    >
      <Metadata title="SMS Analytics" description="SMS Analytics page" />
      <FiltersSlotProvider value={filtersSlot}>
        <SMSAnalyticsTab refreshKey={refreshKey} />
      </FiltersSlotProvider>
    </PageHeaderLayout>
  )
}

export default SMSAnalyticsPage
